import React from 'react'

const FormButtons = ({ children }) =>
  <div className="clearfix form-buttons">
    <div className="pull-right">{ children }</div>
  </div>

export default FormButtons
